<div class="interpretation-container">
    <div class="interpretation-title">{{ 'aumico_annual_report_interpretation_title' | i18next  }}</div>
    <form [formGroup]="interpretationForm">
        <!--The number format is hidden for now and always will have value 1-->
        <!-- <div class="interpretation-header margin-bottom-0">Please select how the numbers will be delivered for each account type</div>
        <div class="interpretation-label">Number format</div>
        <div>
            <mat-button-toggle-group [formControl]="interpretationForm.controls['numberFormat']">
                <mat-button-toggle [value]="NumberFormatEnum.SINGLE">CHF 1</mat-button-toggle>
                <mat-button-toggle [value]="NumberFormatEnum.THOUSAND">CHF 1'000</mat-button-toggle>
                <mat-button-toggle [value]="NumberFormatEnum.MILLION">CHF 1'000'000</mat-button-toggle>
            </mat-button-toggle-group>
        </div>

        <div class="interpretation-separator margin-top-32"></div> -->

        <div class="interpretation-header">
            {{ 'aumico_annual_report_interpretation_select_signs' | i18next  }}
        </div>
        <div class="interpretation-label">
            {{ 'aumico_annual_report_interpretation_active' | i18next  }}
        </div>
        <mat-button-toggle-group [formControl]="interpretationForm.controls['assets']">
            <mat-button-toggle [value]="SignEnum.POSITIVE">{{
                'aumico_annual_report_interpretation_positive' | i18next 
            }}</mat-button-toggle>
            <mat-button-toggle [value]="SignEnum.NEGATIVE">{{
                'aumico_annual_report_interpretation_negative' | i18next 
            }}</mat-button-toggle>
        </mat-button-toggle-group>

        <div class="interpretation-label">
            {{ 'aumico_annual_report_interpretation_passive' | i18next  }}
        </div>
        <mat-button-toggle-group [formControl]="interpretationForm.controls['liabilities']">
            <mat-button-toggle [value]="SignEnum.POSITIVE">{{
                'aumico_annual_report_interpretation_positive' | i18next 
            }}</mat-button-toggle>
            <mat-button-toggle [value]="SignEnum.NEGATIVE">{{
                'aumico_annual_report_interpretation_negative' | i18next 
            }}</mat-button-toggle>
        </mat-button-toggle-group>

        <div class="interpretation-label">
            {{ 'aumico_annual_report_interpretation_income' | i18next  }}
        </div>
        <mat-button-toggle-group [formControl]="interpretationForm.controls['income']">
            <mat-button-toggle [value]="SignEnum.POSITIVE">{{
                'aumico_annual_report_interpretation_positive' | i18next 
            }}</mat-button-toggle>
            <mat-button-toggle [value]="SignEnum.NEGATIVE">{{
                'aumico_annual_report_interpretation_negative' | i18next 
            }}</mat-button-toggle>
        </mat-button-toggle-group>

        <div class="interpretation-label">
            {{ 'aumico_annual_report_interpretation_expense' | i18next  }}
        </div>
        <mat-button-toggle-group [formControl]="interpretationForm.controls['expenses']">
            <mat-button-toggle [value]="SignEnum.POSITIVE">{{
                'aumico_annual_report_interpretation_positive' | i18next 
            }}</mat-button-toggle>
            <mat-button-toggle [value]="SignEnum.NEGATIVE">{{
                'aumico_annual_report_interpretation_negative' | i18next 
            }}</mat-button-toggle>
        </mat-button-toggle-group>
    </form>

    <form [formGroup]="accountFilterForm">
        <br />
        <div>
            <mat-checkbox
                [checked]="false"
                color="primary"
                formControlName="removeAccountWithZeroBalance"
            ></mat-checkbox>
            <span class="interpretation-header">
                {{ 'aumico_annual_report_interpretation_remove_account_with_zero_balance' | i18next  }}
            </span>
        </div>
        <br />

        <div class="interpretation-header">
            {{ 'aumico_annual_report_interpretation_specify_number_of_characters' | i18next  }}
        </div>
        <aum-input [aumFormControl]="accountFilterForm.controls['accountNumber']">
            <aum-form-field-label>{{
                'aumico_annual_report_interpretation_account_number' | i18next 
            }}</aum-form-field-label>
            <aum-form-error *ngIf="accountFilterForm.controls['accountNumber']?.errors?.['invalidAccountNumberInput']">
                {{ 'aumico_annual_report_interpretation_account_number_invalid_input' | i18next  }}
            </aum-form-error>
        </aum-input>

        <br />
        <!-- <aum-input [aumFormControl]="accountFilterForm.controls['accountName']">
            <aum-form-field-label>{{ "aumico_annual_report_interpretation_account_name"| i18next }}</aum-form-field-label>
        </aum-input>
        <br>
        <aum-input [aumFormControl]="accountFilterForm.controls['openingValue']">
            <aum-form-field-label>{{ "aumico_annual_report_interpretation_opening_value"| i18next }}</aum-form-field-label>
        </aum-input>
        <br>
        <aum-input [aumFormControl]="accountFilterForm.controls['closingValue']">
            <aum-form-field-label>{{ "aumico_annual_report_interpretation_closing_value"| i18next }}</aum-form-field-label>
        </aum-input>

        <div class="interpretation-separator"></div>
        <div class="interpretation-header">{{ "aumico_annual_report_interpretation_specify_included_word"| i18next }}</div>
        <aum-input placeholder="{{'aumico_annual_report_interpretation_enter_included_word' | i18next  }}" [aumFormControl]="accountFilterForm.controls['includedWord']">
            <aum-form-field-label>{{ "aumico_annual_report_interpretation_included_word"| i18next }}</aum-form-field-label>
        </aum-input> -->

        <div class="interpretation-header">
            {{ 'aumico_annual_report_interpretation_specify_excluded_word' | i18next  }}
        </div>
        <aum-input
            placeholder="{{ 'aumico_annual_report_interpretation_enter_excluded_word' | i18next  }}"
            [aumFormControl]="accountFilterForm.controls['excludedWord']"
        >
            <aum-form-field-label>{{
                'aumico_annual_report_interpretation_excluded_word' | i18next 
            }}</aum-form-field-label>
        </aum-input>
    </form>
</div>
